import { newAlert } from './alert_actions';
import { sendRequest, completeRequest, errorOnRequest } from './request_state';
import RequestService from '../services/request_service';
import {
  PERMISSIONS_LIST,
  SELECT_PERMISSION,
  PERMISSIONS_NAMES
} from '../constants/action_constants';
import { stringifyQuery } from '../helpers/parseQuerystring';
import { history } from '../helpers/history';

const requestService = new RequestService('node');

function setPermissions(items, meta = {}) {
  return {
    type: PERMISSIONS_LIST,
    data: items,
    meta
  };
}

function setPermissionEdit(item) {
  return {
    type: SELECT_PERMISSION,
    data: item
  };
}

function setPermissionsNames(items) {
  return {
    type: PERMISSIONS_NAMES,
    data: items
  };
}

export const fetchPermission = id => async dispatch => {
  dispatch(sendRequest('FetchPermissionsAdmin'));
  try {
    const payload = await requestService.get(`permissions/admin/${id}`);
    dispatch(setPermissionEdit(payload.data));
  } catch (errors) {
    dispatch(errorOnRequest(errors));
  } finally {
    dispatch(completeRequest('FetchPermissionsAdmin'));
  }
};

export const fetchPermissionsNames = () => async dispatch => {
  dispatch(sendRequest('FetchPermissionsNamesAdmin'));
  try {
    const payload = await requestService.get(`permissions/admin/names`);
    dispatch(setPermissionsNames(payload.data));
  } catch (errors) {
    dispatch(errorOnRequest(errors));
  } finally {
    dispatch(completeRequest('FetchPermissionsNamesAdmin'));
  }
};

export const fetchPermissions = (params = {}) => async dispatch => {
  history.replace(`/permissions?${stringifyQuery(params)}`);
  dispatch(sendRequest('PermissionsAdmin'));
  try {
    const payload = await requestService.get('permissions/admin', params);
    dispatch(setPermissions(payload.data, payload.meta));
    dispatch(completeRequest('PermissionsAdmin'));
  } catch (error) {
    const e = await error.json();
    const errorMsg =
      e.errors.base || e.message || 'Lo sentimos. Algo ha salido mal.';
    dispatch(newAlert('error', 'ERROR:', errorMsg));
    dispatch(completeRequest('PermissionsAdmin'));
  }
};

export const editPermission = (permissionId, params = {}) => async dispatch => {
  dispatch(sendRequest('SavePermission'));
  try {
    const payload = await requestService.put(
      `permissions/${permissionId}`,
      params
    );
    dispatch(newAlert('success', 'Success', payload.data.message));
    dispatch(completeRequest('SavePermission'));
    dispatch(setPermissionEdit({}));
    history.replace(`/permissions`);
  } catch (error) {
    const e = await error.json();
    if (e.statusCode === 403) {
      dispatch(
        newAlert(
          'error',
          'ERROR:',
          'No tienes permiso para editar este permiso.'
        )
      );
      dispatch(completeRequest('SavePermission'));
      return;
    }

    const errorMsg =
      e.errors.base || e.message || 'Lo sentimos. Algo ha salido mal.';
    dispatch(newAlert('error', 'ERROR:', errorMsg));
    dispatch(completeRequest('SavePermission'));
    dispatch(errorOnRequest('SavePermission', e.errors));
  }
};
